import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Todas las pantallas scrollean la ventana, así que sin esto la posición se
// arrastraba de una sección a otra. Cada ruta recuerda su propio scroll: al
// volver a una sección aparece donde se la dejó y una ruta nueva arranca
// arriba de todo.
//
// Los feeds cargan su contenido de forma asíncrona, así que al volver la
// página todavía puede ser más corta que la posición guardada: se reintenta
// durante un rato hasta llegar, salvo que el usuario empiece a scrollear.
const RESTORE_TIMEOUT_MS = 2000;

const ScrollManager = () => {
  const { pathname } = useLocation();
  const positions = useRef({});
  const currentPath = useRef(pathname);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    const onScroll = () => {
      positions.current[currentPath.current] = window.scrollY;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useLayoutEffect(() => {
    currentPath.current = pathname;
    const target = positions.current[pathname] || 0;
    window.scrollTo(0, target);
    if (target === 0) return undefined;

    let frame;
    const start = performance.now();
    const stop = () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("wheel", stop);
      window.removeEventListener("touchstart", stop);
    };
    const retry = () => {
      if (Math.abs(window.scrollY - target) < 2 || performance.now() - start > RESTORE_TIMEOUT_MS) {
        stop();
        return;
      }
      window.scrollTo(0, target);
      frame = requestAnimationFrame(retry);
    };
    window.addEventListener("wheel", stop, { passive: true });
    window.addEventListener("touchstart", stop, { passive: true });
    frame = requestAnimationFrame(retry);
    return stop;
  }, [pathname]);

  return null;
};

export default ScrollManager;
